(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('vue-datepicker-next')) :
  typeof define === 'function' && define.amd ? define(['vue-datepicker-next'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global.DatePicker = global.DatePicker || {}, global.DatePicker.lang = global.DatePicker.lang || {}, global.DatePicker.lang.cs = factory(global.DatePicker)));
}(this, (function (DatePicker) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var DatePicker__default = /*#__PURE__*/_interopDefaultLegacy(DatePicker);

  var locale = {
    months: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'],
    monthsShort: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
    weekdays: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
    weekdaysShort: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
    weekdaysMin: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
    firstDayOfWeek: 1,
    firstWeekContainsDate: 4
  };

  const lang = {
      formatLocale: locale,
      yearFormat: 'YYYY',
      monthFormat: 'MMM',
      monthBeforeYear: true,
  };
  DatePicker__default['default'].locale('cs', lang);

  return lang;

})));
